export default {
  table: 'Table',
  card: 'Card',

  alarmType: 'Alarm Type',
  alarmTime: 'Alarm Time',
  alarmImage: 'Alarm Image',
  alarmVideo: 'Alarm Video',

  alarmTypeLabel: 'Alarm Type:',
  alarmTimeLabel: 'Alarm Time:',
  alarmImageLabel: 'Alarm Image:',

  noAlarmData: 'No alarm data',

  alarmVideoTitle: 'Alarm Video',
  screenshotFileName: 'Screenshot',
}
